export default __webpack_public_path__ + "static/media/google.9ef1983f.png";